if (typeof Main !== " function") {
  let Main = function () {
    let duracion = 400;

    let breakpoint = 576;
    let formato = "horizontal";

    function fetchData() {
      let estados = Window.data.json.estados;
      let params = {};
      params.estados = estados;

      procesaData(params);
    }

    function procesaData(params) {
      generaGraficas(params);
    }

    function generaGraficas(params) {
      let elMapa = d3.select("#mapa_contagios") || false;
      if (!elMapa.empty()) {
        let mapa = new Mapa(elMapa, duracion, formato, {
          estados: params.estados,
        });
        delete window.Mapa;
      }
    }

    function setup() {
      //https://unpkg.com/d3-time-format@2.3.0/locale/es-MX.json
      d3.timeFormatDefaultLocale({
        dateTime: "%x, %X",
        date: "%d/%m/%Y",
        time: "%-I:%M:%S %p",
        periods: ["AM", "PM"],
        days: [
          "domingo",
          "lunes",
          "martes",
          "miércoles",
          "jueves",
          "viernes",
          "sábado",
        ],
        shortDays: ["dom", "lun", "mar", "mié", "jue", "vie", "sáb"],
        months: [
          "enero",
          "febrero",
          "marzo",
          "abril",
          "mayo",
          "junio",
          "julio",
          "agosto",
          "septiembre",
          "octubre",
          "noviembre",
          "diciembre",
        ],
        shortMonths: [
          "ene",
          "feb",
          "mar",
          "abr",
          "may",
          "jun",
          "jul",
          "ago",
          "sep",
          "oct",
          "nov",
          "dic",
        ],
      });
      setFormato();
      fetchData();
    }

    function setFormato() {
      let w = document.documentElement.clientWidth;
      formato = w > breakpoint ? "horizontal" : "vertical";
    }

    setup();
  };

  windowReady.ready(function () {
    let charts = new Main();
  });
}
